import { BaseModal } from "../BaseModal/BaseModal";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Box, Button, Typography } from "@mui/material";

interface IModalDialogConfirm {
  confirmLabel?: string;
  EndIcon?: JSX.Element;
  hasError?: boolean;
  isLoading?: boolean;
  isOpen: boolean;
  message: string;
  onCancel: () => void;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  msgError?: string;
}

export const ModalDialogConfirm = ({
  confirmLabel,
  EndIcon,
  hasError,
  isLoading,
  isOpen,
  message,
  onCancel,
  onClose,
  onConfirm,
  title,
  msgError,
}: IModalDialogConfirm): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <BaseModal
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        isLoading={isLoading}
      >
        <Typography>{message}</Typography>
        {hasError ? (
          <Typography color="warning" variant="caption">
            {msgError}
          </Typography>
        ) : (
          <></>
        )}
        <Box display="flex" gap={2} mt={2}>
          <Button
            sx={{ flexGrow: 1 }}
            disabled={isLoading}
            onClick={onConfirm}
            variant="contained"
            color={hasError ? "error" : "primary"}
            endIcon={EndIcon ? EndIcon : undefined}
          >
            {confirmLabel ? confirmLabel : t("WEG:buttons.confirm")}
          </Button>
          <Button
            sx={{ flexGrow: 1 }}
            disabled={isLoading}
            onClick={onCancel}
            variant="contained"
            color="secondary"
          >
            {t("WEG:buttons.cancel")}
          </Button>
        </Box>
      </BaseModal>
    </>
  );
};
